/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Error, ErrorIcon, ErrorTitle, ErrorDescription } from '@quadminds/mindkit';
import IconDark from '@quadminds/mindy-app/assets/img/errors/ErrorDark.svg';
import IconLight from '@quadminds/mindy-app/assets/img/errors/ErrorLight.svg';
import { useTranslation } from 'react-i18next';

export function LimitExceeded() {
    const { t } = useTranslation();
    return (
        <Error>
            <ErrorIcon>
                <img src={IconLight} alt="Error" className="dark:hidden h-24 w-auto" />
                <img src={IconDark} alt="Error" className="hidden dark:block h-24 w-auto" />
            </ErrorIcon>
            <ErrorTitle>{t('errors.limitReached')}</ErrorTitle>
            <ErrorDescription>{t('errors.limitReachedDescription')}</ErrorDescription>
        </Error>
    );
}

export default LimitExceeded;
